



















































import { defineComponent, PropType, ref, onMounted, watch } from '@nuxtjs/composition-api';
import {
  SfButton,
} from '@storefront-ui/vue';
import { useUiHelpers, useUiState } from '@wemade-vsf/composables';
import { useFilters } from '@wemade-vsf/catalog/lib/runtime/category/composables/useFilters';
import type { Pagination } from '@wemade-vsf/core';
import SelectedFilters from 'components/catalog/Category/Filters/SelectedFilters.vue';
import SkeletonLoader from 'components/theme/SkeletonLoader.vue';
import WmSelect from 'components/theme/Form/Select.vue';
import { SortingModel } from '@wemade-vsf/catalog/lib/runtime/category/composables/useFacet/sortingOptions';
import type { Aggregation } from '@wemade-vsf/magento-api';

export default defineComponent({
  components: {
    SelectedFilters,
    SkeletonLoader,
    WmSelect,    
    SfButton,
  },
  props: {
    sortBy: {
      type: Object as PropType<SortingModel>,
      required: true,
    },
    pagination: {
      type: Object as PropType<Pagination>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    aggregations: {
      type: Array as PropType<Aggregation[]>,
      default: []
    }
  },
  setup(props, { emit }) {
    const {
      toggleFilterSidebar, changeToCategoryListView, changeToCategoryGridView, isCategoryGridView,
    } = useUiState();
    const uiHelpers = useUiHelpers();
    const doChangeSorting = (sort: string) => {
      uiHelpers.changeSorting(sort, false);
      emit('reloadProducts');
    };

    const filters = ref<Aggregation[]>([]);
    const { removableFilters, getRemovableFilters, selectedFilters, removeFilter } = useFilters();

    function updateRemovableFilters () {
      getRemovableFilters(filters.value, selectedFilters.value);
    }

    const doRemoveFilter = ({ id, value }: { id: string, value: string }) => {
      removeFilter(id, value);
      uiHelpers.changeFilters(selectedFilters.value, false);
      updateRemovableFilters();
      emit('reloadProducts');
    };

    watch(() => props.aggregations, (newValue) => {
      filters.value = newValue.filter(f => f.attribute_code !== 'category_id' && f.attribute_code !== 'category_uid');
    }, { immediate: true, deep: true })

    onMounted(() => {
      filters.value = props.aggregations.filter(f => f.attribute_code !== 'category_uid' && f.attribute_code !== 'category_id');
    })

    return {
      toggleFilterSidebar,
      doChangeSorting,
      ...uiHelpers,
      changeToCategoryListView,
      changeToCategoryGridView,
      isCategoryGridView,
      removableFilters,
      doRemoveFilter
    };
  },
});
